export const HelpCrunchService = {
    setUser(user) {
        // @ts-ignore
        window?.HelpCrunch('updateUser', user);
    },
    track(name, json) {
        // @ts-ignore
        window?.HelpCrunch('trackEvent', name, json);
    },
    openChat() {
        // @ts-ignore
        window?.HelpCrunch('openChat');
    },
    enterText(text) {
        // @ts-ignore
        window?.HelpCrunch('typeUserMessage', text);
    },
};
